import { Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from './permission-service';

@Injectable()
export class UserRouteAccessGuard  {
    constructor(private permissionService: PermissionService, private router: Router) {
    }

    canLoad(route: Route): boolean {

        return this.permissionService.hasPermission(...route.data['authorities']);
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const authorities = route.data['authorities'];

        return this.permissionService.hasPermission(...authorities);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
